// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kkzLW6ip {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

/* Hero */
.NJnhE5b4 {
  text-align: center;
  padding: 3rem 0 2rem;
}

.ctZe0Gcl {
  font-size: 3rem;
  font-weight: 800;
  color: #4ecca3;
  margin: 0 0 0.5rem;
  letter-spacing: 2px;
}

.rZnL7BOr {
  font-size: 1.25rem;
  color: #e0e0e0;
  margin: 0 0 1rem;
}

.SFVGb06n {
  font-size: 1rem;
  color: #b0b0c0;
  max-width: 560px;
  margin: 0 auto 2rem;
  line-height: 1.6;
}

.ju4QI7oX {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.S4jHy2OI {
  background: #4ecca3;
  color: #1a1a2e;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: background 0.2s;
}

.S4jHy2OI:hover {
  background: #3db893;
}

.k2tKLzwN {
  background: transparent;
  color: #4ecca3;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  border: 1px solid #4ecca3;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: background 0.2s, color 0.2s;
}

.k2tKLzwN:hover {
  background: rgba(78, 204, 163, 0.1);
}

/* Features */
.BHuxlnNj {
  padding: 2rem 0;
}

.WVesbr9h {
  font-size: 1.5rem;
  color: #e0e0e0;
  text-align: center;
  margin: 0 0 1.5rem;
}

.oeqTkt0y {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.bAvrNfVa {
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 12px;
  padding: 1.5rem;
  transition: border-color 0.2s;
}

.bAvrNfVa:hover {
  border-color: #4ecca3;
}

.RdgoEMwI {
  font-size: 2rem;
  margin-bottom: 0.75rem;
}

.ehFS0QEK {
  font-size: 1.1rem;
  color: #e0e0e0;
  margin: 0 0 0.5rem;
}

._b5rkBKh {
  font-size: 0.9rem;
  color: #b0b0c0;
  margin: 0;
  line-height: 1.5;
}

/* Leaderboard */
.A_Qh8ah3 {
  padding: 2rem 0;
}

.KHsq5KT4,
._iSCWn5E {
  text-align: center;
  color: #808090;
  font-size: 0.95rem;
}

.cVR7ppRW {
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 12px;
  overflow: hidden;
}

.uKs_3iQo {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #2a2a4a;
}

.uKs_3iQo:last-child {
  border-bottom: none;
}

.zdXZQuOU {
  width: 2rem;
  font-weight: 700;
  color: #4ecca3;
  font-size: 1.1rem;
}

.HbtaPFPR {
  flex: 1;
  color: #e0e0e0;
}

.RaJYfQmv {
  color: #4ecca3;
  font-weight: 600;
}

.SJJhyEQY {
  display: block;
  text-align: center;
  margin-top: 1rem;
  color: #4ecca3;
  text-decoration: none;
  font-size: 0.95rem;
}

.SJJhyEQY:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .ctZe0Gcl {
    font-size: 2.25rem;
  }

  .oeqTkt0y {
    grid-template-columns: 1fr;
  }

  .ju4QI7oX {
    flex-direction: column;
    align-items: center;
  }
}

/* Responsive: 480px phone breakpoint */
@media (max-width: 480px) {
  .kkzLW6ip {
    padding: 1rem 0.5rem;
  }

  .ctZe0Gcl {
    font-size: 2rem;
  }

  .rZnL7BOr {
    font-size: 1.1rem;
  }

  .bAvrNfVa {
    padding: 1rem;
  }

  .uKs_3iQo {
    padding: 0.5rem 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Landing.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n}\n\n/* Hero */\n.hero {\n  text-align: center;\n  padding: 3rem 0 2rem;\n}\n\n.heroTitle {\n  font-size: 3rem;\n  font-weight: 800;\n  color: #4ecca3;\n  margin: 0 0 0.5rem;\n  letter-spacing: 2px;\n}\n\n.heroSubtitle {\n  font-size: 1.25rem;\n  color: #e0e0e0;\n  margin: 0 0 1rem;\n}\n\n.heroDescription {\n  font-size: 1rem;\n  color: #b0b0c0;\n  max-width: 560px;\n  margin: 0 auto 2rem;\n  line-height: 1.6;\n}\n\n.ctaButtons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n}\n\n.ctaPrimary {\n  background: #4ecca3;\n  color: #1a1a2e;\n  padding: 0.75rem 2rem;\n  border-radius: 8px;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: background 0.2s;\n}\n\n.ctaPrimary:hover {\n  background: #3db893;\n}\n\n.ctaSecondary {\n  background: transparent;\n  color: #4ecca3;\n  padding: 0.75rem 2rem;\n  border-radius: 8px;\n  border: 1px solid #4ecca3;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: background 0.2s, color 0.2s;\n}\n\n.ctaSecondary:hover {\n  background: rgba(78, 204, 163, 0.1);\n}\n\n/* Features */\n.features {\n  padding: 2rem 0;\n}\n\n.sectionTitle {\n  font-size: 1.5rem;\n  color: #e0e0e0;\n  text-align: center;\n  margin: 0 0 1.5rem;\n}\n\n.featureGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.featureCard {\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 12px;\n  padding: 1.5rem;\n  transition: border-color 0.2s;\n}\n\n.featureCard:hover {\n  border-color: #4ecca3;\n}\n\n.featureIcon {\n  font-size: 2rem;\n  margin-bottom: 0.75rem;\n}\n\n.featureTitle {\n  font-size: 1.1rem;\n  color: #e0e0e0;\n  margin: 0 0 0.5rem;\n}\n\n.featureText {\n  font-size: 0.9rem;\n  color: #b0b0c0;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Leaderboard */\n.leaderboard {\n  padding: 2rem 0;\n}\n\n.loadingText,\n.emptyText {\n  text-align: center;\n  color: #808090;\n  font-size: 0.95rem;\n}\n\n.leaderList {\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.leaderRow {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid #2a2a4a;\n}\n\n.leaderRow:last-child {\n  border-bottom: none;\n}\n\n.leaderRank {\n  width: 2rem;\n  font-weight: 700;\n  color: #4ecca3;\n  font-size: 1.1rem;\n}\n\n.leaderName {\n  flex: 1;\n  color: #e0e0e0;\n}\n\n.leaderScore {\n  color: #4ecca3;\n  font-weight: 600;\n}\n\n.leaderboardLink {\n  display: block;\n  text-align: center;\n  margin-top: 1rem;\n  color: #4ecca3;\n  text-decoration: none;\n  font-size: 0.95rem;\n}\n\n.leaderboardLink:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 600px) {\n  .heroTitle {\n    font-size: 2.25rem;\n  }\n\n  .featureGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .ctaButtons {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n/* Responsive: 480px phone breakpoint */\n@media (max-width: 480px) {\n  .container {\n    padding: 1rem 0.5rem;\n  }\n\n  .heroTitle {\n    font-size: 2rem;\n  }\n\n  .heroSubtitle {\n    font-size: 1.1rem;\n  }\n\n  .featureCard {\n    padding: 1rem;\n  }\n\n  .leaderRow {\n    padding: 0.5rem 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `kkzLW6ip`,
	"hero": `NJnhE5b4`,
	"heroTitle": `ctZe0Gcl`,
	"heroSubtitle": `rZnL7BOr`,
	"heroDescription": `SFVGb06n`,
	"ctaButtons": `ju4QI7oX`,
	"ctaPrimary": `S4jHy2OI`,
	"ctaSecondary": `k2tKLzwN`,
	"features": `BHuxlnNj`,
	"sectionTitle": `WVesbr9h`,
	"featureGrid": `oeqTkt0y`,
	"featureCard": `bAvrNfVa`,
	"featureIcon": `RdgoEMwI`,
	"featureTitle": `ehFS0QEK`,
	"featureText": `_b5rkBKh`,
	"leaderboard": `A_Qh8ah3`,
	"loadingText": `KHsq5KT4`,
	"emptyText": `_iSCWn5E`,
	"leaderList": `cVR7ppRW`,
	"leaderRow": `uKs_3iQo`,
	"leaderRank": `zdXZQuOU`,
	"leaderName": `HbtaPFPR`,
	"leaderScore": `RaJYfQmv`,
	"leaderboardLink": `SJJhyEQY`
};
export default ___CSS_LOADER_EXPORT___;
